import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import "./CdHours.scss";
import CdHour from './CdHour'

function CdHours(props) {
	const [hours] = useState(props.hours);
		
	return (
		<div className="cd-hours">
			<Container className="pb-4">
				<Row className="cd-hours-body">
					{hours.map((hour, i) => {
						return (
							(props.type === 'gate') ? 
								<CdHour action={props.action} type={"gate"} capacidade={hour.capacidade} intervalo={hour.intervalo} key={i} hours={props.hours} hour={hour} indice={i} dynamicCapacity={props.dynamicCapacity}/> 
							: 
								<CdHour type={"cd"} key={i} hours={props.hours} hour={hour} indice={i} /> 
						)
					})}
				</Row>
			</Container>
		</div>
	)
	
}

export default CdHours;